import React, { useEffect, useState } from "react";
import cal_link_maker from "../../Functions/cal_link_maker";
import { Backtotop, Eventcard } from "../../widgets";
import "./Freshers_asso.css";
import { Listformat } from "../../components";
import { freshers_events } from "../../constants/freshers_asso";
import {FaComputer} from 'react-icons/fa6'
import { incubation_menu } from "../../constants/incubation";
import {
  vision,
  mission_data,
  freshers_asso_logo,
  freshers_asso_heroimage_carousalinfo,
  Objective,
  freshersmenu
} from "../../constants/freshers_asso";

import { Heroimagecarousal,RadialMenu } from "../../components";
import { Deptvision, Deptmission, Underline,Floatinmenu } from "../../widgets";

const Freshers_asso = () => {
  useEffect(() => {
    document.title = "ACCET-Freshers' Association";
  }, []);
  // Move event logic to main component scope
  const cardsToShowInitially = 12;
  const cardsIncrement = 4;

  const totalCards = freshers_events.length;

  const [visibleCards, setVisibleCards] = useState(cardsToShowInitially);

  const handleReadMoreClick = () => {
    const newVisibleCards = visibleCards + cardsIncrement;
    setVisibleCards(Math.min(newVisibleCards, totalCards));
  };

  const handleReadLessClick = () => {
    setVisibleCards(cardsToShowInitially);
  };

  const shouldShowReadMore = visibleCards < totalCards;
  const shouldShowReadLess = visibleCards === totalCards;
  return (
    <div className="freshersdept">
      <Heroimagecarousal
        key={freshers_asso_heroimage_carousalinfo.id}
        title={freshers_asso_heroimage_carousalinfo.title}
        img_list={freshers_asso_heroimage_carousalinfo.img_list}
      ></Heroimagecarousal>
      <section className="freshersdark">
        <div className="dept_float_menu">
          <Floatinmenu logo={FaComputer} head="Menu" links={freshersmenu} />
        </div>
        <RadialMenu menu_links={freshersmenu} />
        <div className="freshers_about">
          <Underline heading="About" />
        <div className="freshers_asso_flex">
          <p className="freshers_asso_cont">
            The Freshers' Association of ACGCET is dedicated to welcoming and
            guiding new students as they begin their journey at our college. Our
            mission is to help freshers adapt to campus life, foster
            friendships, and build confidence through a variety of engaging
            activities. We organize orientation programs, interactive workshops,
            and fun events to ensure every fresher feels included and supported.
            By connecting seniors and juniors, the association creates a
            friendly environment where freshers can seek guidance, develop new
            skills, and actively participate in college life from day one.
          </p>
          <div className="freshers_asso_img_holder">
            <img
              className="freshers_asso_img"
              src={freshers_asso_logo}
              alt="freshers_asso_image"
            />
          </div>
        </div>
        <div className="freshers_asso_obj">
          <p>
            <b>Staff in charge:</b> Dr.S.R.Cynthia Assistant Professor/Physics
            <br />
            <b>Student president:</b> ABHIRAJ K Final year EEE
          </p>
        </div>
         </div>
        {/* <div className="freshers_asso_underline">
          <Underline heading="Vision & Mission" />
        </div>
        <div className="freshers_asso_vis">
          <Deptvision visiondata={vision.visiondata} />
          <Deptmission points={mission_data} />
        </div> */}

        <div className="freshers_asso_underline">
          <Underline heading="Objective" />
        </div>

        <div className="freshers_asso_obj_list">
          <Listformat points={Objective} />
        </div>
        <div className="gapo1">
          {/* <div className="events" id="home_events">
            <p className="head">Events</p>
          </div> */}
          {/* <div className="row row-cols-lg-4 row-cols-2 g-3 ">
            {freshers_events.slice(0, visibleCards).map((event) => {
              let gcal_link = cal_link_maker(
                event.title,
                event.date,
                event.time,
                event.details,
                event.venue,
                event.button
              );
              return (
                <Eventcard
                  key={event.id}
                  date={event.date}
                  title={event.title}
                  time={event.time}
                  venue={event.venue}
                  cal_link={gcal_link}
                  status={event.status}
                  button={event.button}
                />
              );
            })}
          </div> */}
          <div className="event__knowmore-btn-container">
            {shouldShowReadMore && (
              <div
                className="event__read_more event__read_button"
                onClick={handleReadMoreClick}
              >
                Read More
              </div>
            )}

            {totalCards > cardsToShowInitially && shouldShowReadLess && (
              <div
                className="event__read_less event__read_button"
                onClick={handleReadLessClick}
              >
                Read Less
              </div>
            )}
          </div>
        </div>
      </section>
      <Backtotop />
    </div>
  );
};

export default Freshers_asso;
